<script setup>
import { computed, defineProps } from 'vue'
import { formatCurrency, formatDecimals } from '@/helpers/stringHelpers'

const props = defineProps({
  summary: {
    type: Array,
    required: true
  }
})

const bodyRows = computed(() => {
  return props.summary.filter((row) => row.type !== 'Total')
})

const totalRow = computed(() => {
  return (
    props.summary.find((row) => row.type === 'Total') || {
      type: 'Total',
      weight: 0,
      quantity: 0,
      dockets: 0,
      invoiceTotal: 0,
      splitPrice: 0
    }
  )
})

function formatDockets(row) {
  return row.dockets ?? '-'
}
</script>

<template>
  <v-simple-table dense>
    <thead>
      <tr class="bg-light-blue">
        <th>Type</th>
        <th class="text-end">Weight</th>
        <th class="text-end">Quantity</th>

        <th class="text-end">Dockets</th>
        <th class="text-end">Invoice Total</th>
      </tr>
    </thead>

    <tbody>
      <tr
        v-for="row in bodyRows"
        :key="row.type"
        :class="{ 'revenue-summary-sub-row': row.isSubRow }"
      >
        <td
          class="text-start"
          :class="{
            'font-weight-semibold font-italic': !row.isSubRow,
            'revenue-summary-sub-label ps-6': row.isSubRow
          }"
        >
          <span v-if="row.isSubRow">↳ {{ row.type }}</span>
          <span v-else>{{ row.type }}</span>
        </td>

        <td class="text-end">{{ formatDecimals(row.weight) }}kg</td>

        <td class="text-end">
          {{ row.quantity }}
        </td>

        <td class="text-end">
          {{ formatDockets(row) }}
        </td>

        <td class="text-end">
          {{ formatCurrency(row.invoiceTotal) }}
        </td>
      </tr>
    </tbody>

    <tfoot>
      <tr class="revenue-summary-total">
        <td class="font-weight-bold text-start">Total</td>

        <td class="text-end">{{ formatDecimals(totalRow.weight) }}kg</td>

        <td class="text-end">
          {{ totalRow.quantity }}
        </td>

        <td class="text-end">
          {{ totalRow.dockets }}
        </td>

        <td class="text-end">
          {{ formatCurrency(totalRow.invoiceTotal) }}
        </td>
      </tr>
    </tfoot>
  </v-simple-table>
</template>

<style scoped>
.revenue-summary-total > td {
  border-top: 1px solid #677787 !important;
}

.font-weight-semibold {
  font-weight: 600;
}

.revenue-summary-sub-row {
  background: #e9e9e975;
}

.revenue-summary-sub-label {
  color: #6f7d88;
}

.revenue-summary-sub-row td:not(:first-child) {
  color: #333;
}
</style>
